// Generated from package.json. Do not edit manually.
export const APP_VERSION = 'v 2.3.4';
